const estagiosPedido = {
  aguardo: 0,
  aceito: 1,
  negado: 2,
  preparacao: 3,
  pronto: 4,
  rota_entrega: 5,
  entregue: 6,
  faturado: 7,
  separado: 8,
  cancelado: 9,
  cancelado_cliente: 10,
  retirada: 11,
  separacao: 12,
};

export default estagiosPedido;
